
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'5-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            메뉴 관리 - 공연 {{ $route.query.performance_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.performance_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='performance_title'>타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'performance_title'
                maxLength="20"
                placeholder = "타이틀을 입력해 주세요.(20자 이내)"
                v-model="formData.performanceTitle"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.performanceTitleError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='performance_sub_title'>서브 타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'performance_sub_title'
                maxLength="20"
                placeholder = "타이틀을 입력해 주세요.(20자 이내)"
                v-model="formData.performanceSubTitle"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.performanceSubTitleError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='performance_status'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="performance_status"
                v-model="formData.performanceStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_imgBanner_BoxWrap">
            <div class="Admin_imgBanner_BoxTit">메인 노출 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 600 x 840px</p>
                <label for='performance_main_image' class="Admin_imgBanner_Btn">
                  {{ $route.query.performance_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'performance_main_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="changeImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_PerformanceImg">
                  <img
                    :src="formData.performanceMainImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.performanceMainImageURL"
                    alt="PC용 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.performanceMainImageURLError}}</p>
              </div>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='performance_editor'>PC 상세페이지</label>
              <custom-textarea
                v-model="formData.performanceEditor"
                :id="'performance_editor'"
              />
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='performance_editor_mobile'>모바일 상세페이지</label>
              <custom-textarea
                v-model="formData.performanceEditorMobile"
                :id="'performance_editor_mobile'"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import CustomTextarea from '../../ETC/CustomTextarea.vue'
import { editorsReady } from '../../ETC/editor/form'
import {
  get_performance_one,
  insert_performance,
  update_performance
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminPerformanceManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner,
    CustomTextarea
  },
  setup () {
    return {
      formData: ref({
        performanceTitle: '',
        performanceSubTitle: '',
        performanceStatus: 1,
        performanceMainImage: '',
        performanceMainImageURL: '',
        performanceEditor: '',
        performanceEditorMobile: ''
      }),
      errorData: ref({
        performanceTitleError: '',
        performanceSubTitleError: '',
        performanceMainImageURLError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    changeImage: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.performanceMainImage = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.performanceMainImageURL = reader.result
        }
      }
    },
    check_form: function () {
      // 업로드 중인 이미지가 본문에서 누락되지 않도록 저장 전에 확인한다.
      if (!editorsReady(this)) return
      let continue_add = true
      if (this.formData.performanceTitle === '') {
        this.errorData.performanceTitleError = '타이틀을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.performanceTitleError = ''
      }
      if (this.formData.performanceSubTitle === '') {
        this.errorData.performanceSubTitleError = '서브 타이틀을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.performanceSubTitleError = ''
      }
      if (this.formData.performanceMainImageURL === '') {
        this.errorData.performanceMainImageURLError = '메인 노출 이미지를 등록해 주세요.'
        continue_add = false
      } else {
        this.errorData.performanceMainImageURLError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.performance_ID === undefined) {
          insert_performance(
            this.formData.performanceTitle,
            this.formData.performanceSubTitle,
            this.formData.performanceMainImage,
            this.formData.performanceEditor,
            this.formData.performanceEditorMobile,
            this.formData.performanceStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminPerformanceManagement'
          })
        } else {
          update_performance(
            this.$route.query.performance_ID,
            this.formData.performanceTitle,
            this.formData.performanceSubTitle,
            this.formData.performanceMainImage,
            this.formData.performanceEditor,
            this.formData.performanceEditorMobile,
            this.formData.performanceStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminPerformanceManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.performance_ID !== undefined) {
      get_performance_one(this.$route.query.performance_ID).then((result) => {
        this.formData.performanceTitle = result[0].performance_title
        this.formData.performanceSubTitle = result[0].performance_sub_title
        this.formData.performanceMainImageURL = result[0].performance_main_image
        this.formData.performanceEditor = result[0].performance_editor
        this.formData.performanceEditorMobile = result[0].performance_editor_mobile
        this.formData.performanceStatus = result[0].performance_status
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MenuManagement/AdminPerformanceManagementAdd.vue